<template lang="pug">
    Tabs.purchase-list.pagination
        el-card.contains-table(shadow="always")
            Reserve(id="sales-reserve" context="SALES")
           
</template>

<i18n>
    {
        "de": {
            "Stock": "Lager"
        }
    }
</i18n>

<script>
import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'
import Tabs from '@/extensions/shop/views/Partials/SalesTabs'

import Reserve from '@/extensions/shop/pointOfSale/views/Reserve.vue'

import { usePosSetupStore, useSetupStore, useShopStockStore } from '@/stores'

export default {
    name: 'SalesReserve',
    data() {
        return {
            value: ""
        }
    },
    components: {
        PropertyValue,
        Tabs,
        Reserve
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        shopStockStore() {
            return useShopStockStore();
        },
        stock: {
            get() {
                if (this.activeStock) return this.activeStock.name
                else return ""
            },
            set(value) {
                let activeStock = _.find(this.options.stock.items, stock => stock.name == value);
                this.posSetupStore.updateActiveStock(activeStock)
                this.posSetupStore.setActiveStock(activeStock)
            }
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        stocks() {
            return this.shopStockStore.stocks;
        },
        activeStock() {
            return this.posSetupStore.activeStock;
        },
        options() {
            return this.posSetupStore.options;
        }
    },
    watch: {
        // The queue belongs to the selected store, so switching stores has to
        // refetch it - otherwise the previous store's work stays on screen.
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (!reload) return;

            this.initialize('SALES');
            this.fetchStocks();
        },
    },

    methods: {
        initialize(context) {
            return this.posSetupStore.initialize(context);
        },
        fetchStocks() {
            return this.shopStockStore.fetchStocks();
        }
    },
    mounted() {
        this.initialize("SALES");
        //TODO kann auf fetchStocks hier verzichtet werden?
        this.fetchStocks();
        this.$emit('focus-search')
    }
}
</script>

<style lang="sass">
#sales-reserve
    .scroll-box
        height: auto
        position: relative

body.sales-reserve
    aside, header.el-header
        display: block
    &.show-navigation
        aside, header.el-header
            display: block
</style>